import React from 'react';
import { Row, Col, CustomInput } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js";
import ParadigmaLabeledInput from "../../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";

import api from '../../../../api/api.js';

const VisitantesConfig = ({ state, setState }) => {
  return (
    <Row>
      <Col>
        <div className="bg-info w-100 text-center"><small>No Registrados</small></div>
        <CustomInput
          type="checkbox"
          id={`Filtro-AnnonymousUser_AllowVistaArticulos`}
          label="Visualizar Artículos en Web"
          checked={state.AnnonymousUser_AllowVistaArticulos}
          onClick={(evt) => {
            evt.preventDefault();
            setTimeout(() => setState({ AnnonymousUser_AllowVistaArticulos: !state.AnnonymousUser_AllowVistaArticulos }), 100);
          }}
        />
        <CustomInput
          type="checkbox"
          id={`Filtro-AnnonymousUser_AllowVistaPreciosDeArticulos`}
          label="Visualizar Artículos con Precios"
          checked={state.AnnonymousUser_AllowVistaPreciosDeArticulos && state.AnnonymousUser_AllowVistaArticulos}
          onClick={(evt) => {
            evt.preventDefault();
            setTimeout(() => setState({ AnnonymousUser_AllowVistaPreciosDeArticulos: !state.AnnonymousUser_AllowVistaPreciosDeArticulos }), 100);
          }}
        />
        <CustomInput
          type="checkbox"
          id={`Filtro-AnnonymousUser_AllowVistaArticulosSinStock`}
          label="Visualizar Artículos Sin Stock"
          checked={state.AnnonymousUser_AllowVistaArticulosSinStock && state.AnnonymousUser_AllowVistaArticulos}
          onClick={(evt) => {
            evt.preventDefault();
            setTimeout(() => setState({ AnnonymousUser_AllowVistaArticulosSinStock: !state.AnnonymousUser_AllowVistaArticulosSinStock }), 100);
          }}
        />

        <ParadigmaLabeledInput
          xs={[6, 6]}
          label={"Lista de Precio a Usar"}
          inputComponent={
            <ParadigmaAsyncSeeker
              disabled={false}
              url={api.gestion.precios.listas}
              value={state.ListaDePreciosDefecto}
              displayField="Nombre"
              valueField="Codigo"
              parameters={{ paginationEnabled: "False", filters: ["DeBaja=False", "Codigo[not]=000000"], sort: ["Nombre"] }}
              onChange={(data) => setState({ ListaDePreciosDefecto: (data ? data.Codigo : null) })}
            />
          }
        />
        <ParadigmaLabeledInput
          xs={[6, 6]}
          label={"Condición de Pago Defecto"}
          inputComponent={
            <ParadigmaAsyncSeeker
              disabled={false}
              url={api.gestion.ventas.condicionesdepago}
              value={state.CondicionDePagoDefecto}
              displayField="Nombre"
              valueField="Codigo"
              parameters={{ paginationEnabled: "False", filters: ["DeBaja=False"] }}
              onChange={(data) => setState({ CondicionDePagoDefecto: (data ? data.Codigo : null) })}
            />
          }
        />
        <div className="my-1 bg-info w-100 text-center"><small>Registración de Clientes</small></div>
        <CustomInput
          type="checkbox"
          id={`Filtro-LoggedClient_AllowCreation`}
          label="Habilitar Registración"
          checked={state.LoggedClient_AllowCreation}
          onClick={(evt) => {
            evt.preventDefault();
            setTimeout(() => setState({ LoggedClient_AllowCreation: !state.LoggedClient_AllowCreation }), 100);
          }}
        />


        <ParadigmaLabeledInput
          xs={[6, 6]}
          label={"Transporte Defecto"}
          inputComponent={
            <ParadigmaAsyncSeeker
              disabled={false}
              url={api.gestion.generales.transportes}
              value={state.TransporteDefecto}
              displayField="Nombre"
              valueField="Codigo"
              parameters={{ paginationEnabled: "False", filters: ["DeBaja=False"] }}
              onChange={(data) => setState({ TransporteDefecto: (data ? data.Codigo : null) })}
            />
          }
        />
        <small>Se le asignara la lista de precios a usar para <strong>no registrados</strong>.</small><br/>
        <small>Se le asignara la condición de pago defecto a usar para <strong>no registrados</strong>.</small>

        <div className="bg-info w-100 text-center"><small>Registrados</small></div>
        <CustomInput
          type="checkbox"
          id={`Filtro-LoggedClient_AllowLogin`}
          label="Login de Clientes"
          checked={state.LoggedClient_AllowLogin}
          onClick={(evt) => {
            evt.preventDefault();
            setTimeout(() => setState({ LoggedClient_AllowLogin: !state.LoggedClient_AllowLogin }), 100);
          }}
        />
        <CustomInput
          type="checkbox"
          id={`Filtro-LoggedClient_AllowVistaArticulosSinStock`}
          label="Visualizar Artículos Sin Stock"
          checked={state.LoggedClient_AllowVistaArticulosSinStock}
          onClick={(evt) => {
            evt.preventDefault();
            setTimeout(() => setState({ LoggedClient_AllowVistaArticulosSinStock: !state.LoggedClient_AllowVistaArticulosSinStock }), 100);
          }}
        />
        <CustomInput
          type="checkbox"
          id={`Filtro-LoggedClient_EsRevendedor`}
          label="Usa Margen de Rentabilidad"
          checked={state.LoggedClient_EsRevendedor}
          onClick={(evt) => {
            evt.preventDefault();
            setTimeout(() => setState({ LoggedClient_EsRevendedor: !state.LoggedClient_EsRevendedor }), 100);
          }}
        />
        <small>Se le permite incrementar el Precio de Venta sujeto a un margen de rentabilidad definido por el <strong>usuario</strong>.</small>

        <div className="my-1 bg-info w-100 text-center"><small>SIGE: Clientes y Resumenes de Cta Cte</small></div>
        <CustomInput
          type="checkbox"
          id={`Filtro-LoggedClient_AllowImport`}
          label="Importar Clientes desde SIGE"
          checked={state.LoggedClient_AllowImport}
          onClick={(evt) => {
            evt.preventDefault();
            setTimeout(() => setState({ LoggedClient_AllowImport: !state.LoggedClient_AllowImport }), 100);
          }}
        />
        <CustomInput
          type="checkbox"
          id={`Filtro-LoggedClient_AllowExport`}
          label="Exportar Clientes a SIGE"
          checked={state.LoggedClient_AllowExport}
          onClick={(evt) => {
            evt.preventDefault();
            setTimeout(() => setState({ LoggedClient_AllowExport: !state.LoggedClient_AllowExport }), 100);
          }}
        />
        <CustomInput
          type="checkbox"
          id={`Filtro-LoggedClient_AlmacenarComprobantesMovCC`}
          label="Almacenar los Comprobantes asociados a Movimientos de Cta Cte"
          checked={state.LoggedClient_AlmacenarComprobantesMovCC}
          onClick={(evt) => {
            evt.preventDefault();
            setTimeout(() => setState({ LoggedClient_AlmacenarComprobantesMovCC: !state.LoggedClient_AlmacenarComprobantesMovCC }), 100);
          }}
        />
        <small>Se almacenan los comprobantes asociados a movimientos listados en Resumenes de Cta Cte.</small>

      </Col>
    </Row>
  )
}
export default VisitantesConfig;


// WEBPACK FOOTER //
// ./src/views/Gestion/Sitio/Configuracion/VisitantesConfig.js